import axios from "axios";

const SaveCustomerCheckoutUrl = async (customerId, checkoutUrl) => {
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_SHOPIFY_PROXY_URL}/api/graphql`,
      method: "POST",
      data: {
        query: `mutation {
          metafieldsSet(
            metafields: [
              {
                ownerId: "${customerId}",
                namespace: "integration",
                key: "last_customizer_checkout_url",
                value: "${checkoutUrl}",
                type: "url",
              }
            ]
          ) {
            metafields {
              key
              namespace
              value
            }
          }
        }`,
      },
    });
    if (response.data.body.data.metafieldsSet) {
      const { metafields } = response.data.body.data.metafieldsSet;
      if (metafields.length) {
        return true;
      } else {
        return false;
      }
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default SaveCustomerCheckoutUrl;
